import { Fragment } from 'react'
import { parseWhatsAppMarkup, type MarkupNode } from '@sac/contracts'

/**
 * O texto de uma mensagem, com a formatação que o WhatsApp usa.
 *
 * Em nós do React, nunca em HTML: o texto é escrito por clientes, e `dangerouslySetInnerHTML`
 * com texto de terceiro é o caminho mais curto para injeção. A árvore vem de `@sac/contracts`,
 * onde a regra de quando um marcador vale é testada.
 *
 * As quebras de linha ficam a cargo do CSS (`white-space: pre-wrap` na bolha) — quebrar em
 * `<br>` aqui perderia o recuo de listas, que é metade do motivo de uma mensagem ter quebras.
 */
function render(nodes: MarkupNode[]): React.ReactNode {
  return nodes.map((n, i) => {
    if (n.type === 'text') return <Fragment key={i}>{n.value}</Fragment>
    const dentro = render(n.children)
    if (n.type === 'bold') return <strong key={i}>{dentro}</strong>
    if (n.type === 'italic') return <em key={i}>{dentro}</em>
    if (n.type === 'strike') return <s key={i}>{dentro}</s>
    return (
      <code key={i} className="rt-mono">
        {dentro}
      </code>
    )
  })
}

export function RichText({ text }: { text: string }) {
  return <>{render(parseWhatsAppMarkup(text))}</>
}
